"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _react = _interopRequireDefault(require("react")),
    _getAddonsByType = _interopRequireDefault(require("../api/getAddonsByType")),
    _RequestProvider = _interopRequireDefault(require("../../RequestProvider")),
    _AuthorisationWrapper = require("../../AuthorisationWrapper"),
    _AddonsProvider = _interopRequireDefault(require("../components/AddonsProvider"));

function AddonsProvider(props) {
  return _react["default"].createElement(_RequestProvider["default"], {
    requests: {
      getAddonsByType: (0, _getAddonsByType["default"])()
    }
  }, function (requests) {
    return _react["default"].createElement(_AuthorisationWrapper.AuthorisationConsumer, null, function (_ref) {
      var _ref$selectedOrganisa = _ref.selectedOrganisation,
          billingEntityCode = _ref$selectedOrganisa.billingEntityCode,
          includedAddonTypes = _ref$selectedOrganisa.includedAddonTypes;
      return _react["default"].createElement(_AddonsProvider["default"], (0, _extends2["default"])({
        billingEntityCode: billingEntityCode,
        includedAddons: includedAddonTypes
      }, requests, props));
    });
  });
}

var _default = AddonsProvider;
exports["default"] = _default;